<template>
  <DropdownMenu
    data-testid="options-selector"
    class="options-selector"
    :items="selectorOptions"
    :top="top"
    :offsetY="offsetY"
    :disabled="disableSelector || !disableWarningTooltip"
    @item-clicked="onOptionSelected">

    <v-tooltip top :disabled="disableWarningTooltip">

      <template v-slot:activator="{ on, attrs }" >
        <v-btn
          v-on="on"
          v-bind="attrs"
          data-testid="selector-btn"
          @click="openSelector"
          class="action-item" rounded fab small depressed>
          <v-icon color="#596671">{{selectedItem.icon}}</v-icon>
        </v-btn>
      </template>

      <span>{{warningTooltipText}}</span>
    </v-tooltip>

  </DropdownMenu>

</template>

<script>

import DropdownMenu from "@/modules/common/components/DropdownMenu/DropdownMenu";

export default {
  name: "OptionsSelector",
  components: {
    DropdownMenu
  },
  props: {
    selectorOptions : {
      type: Array,
      required: true
    },
    defaultValue: {
      type: String,
      required: false
    },
    canOpenSelector : {
      type: Boolean,
      default: true
    },
    disableSelector: {
      type: Boolean,
      required: false
    },
    disableWarningTooltip: {
      type: Boolean,
      default: true
    },
    tooltipText: {
      type: String,
      required: false
    },
    top: {
      type: Boolean,
      required: false
    },
    offsetY: {
      type: Boolean,
      required: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItem: null
    }
  },
  created() {
    this.setSelected();
  },
  watch: {
    defaultValue() {
      this.setSelected()
    }
  },
  computed: {
    warningTooltipText() {
      return this.tooltipText || this.$t('common.errors.no_options')
    }
  },
  methods: {
    setSelected() {
      this.selectedItem = this.defaultValue ? this.selectorOptions.find((item) => item.value === this.defaultValue) :  this.selectorOptions[0];
    },
    onOptionSelected(option) {
      this.selectedItem = option;
      this.$emit('option-clicked', { ...option })
    },
    openSelector() {
      this.$emit('open-selector')
    }
  }
}
</script>
